import { render as l } from "./render.js";
import { mount as c, unmount as f } from "./mount.js";
function m(r) {
  return l(this, this.instance, r);
}
function d(r = {}) {
  const { id: n, ssr: t, props: e, head: o = !1, force: a = !1, anchorMetaName: i, parent: s } = r;
  return c(this.instance, this, n, e, o, a, i, s, t);
}
function h(r = {}) {
  const { id: n, parent: t } = r;
  f(this.instance, this, n, t);
}
const u = function(r, n, t, e) {
  return {
    instance: r,
    $: n,
    props: t,
    children: e,
    els: [],
    render: m,
    mount: d,
    unmount: h
  };
}, w = function(r, n, t, e) {
  return Array.isArray(n) ? u(r, { $: null }, null, n) : Array.isArray(t) ? u(r, n, null, t) : Array.isArray(e) ? u(r, n, t, e) : u(r, n, t, null);
};
export {
  w as c
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/css-render@0.15.14/~/css-render/esm/c.js
// module id = 1367
// module chunks = 67